module.exports = __webpack_public_path__ + "img/324b2a5.jpg";